import PropTypes from 'prop-types';
import React from 'react';
import { generateCertBlobTdg } from '../../../../../TrainingRoutes/Certificates/TDGCertificate/TDGCertBlob';
import PrimaryButton from '../../../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import { httpUploadCertificate } from '../../../../../Hooks/user/user.post.hooks';
// Creates the certificate for the tdg combo of update and download
const TDGCertificate = ({
  name,
  dateCompleted,
  expiryDate,
  employer,
  address,
  courseId,
  setStatus,
  userId,
}) => {
  const generateAndUploadCertificate = async () => {
    try {
      const pdfBlob = await generateCertBlobTdg(
        name,
        dateCompleted,
        expiryDate,
        employer,
        address
      );
      const formData = new FormData();
      formData.append('certificate', pdfBlob, `${name}-TDG.pdf`);
      formData.append('userId', userId);
      formData.append('courseId', courseId);
      setStatus('Certificate uploaded successfully');
      const response = await httpUploadCertificate(formData);
      if (response.ok) {
        setStatus('Certificate uploaded successfully');
      } else {
        setStatus('Error uploading certificate');
      }
    } catch (error) {
      setStatus('Error generating certificate');
    }
  };

  return (
    <>
      <PrimaryButton
        span="Download & Upload Certificate"
        functionName={generateAndUploadCertificate}
      />
    </>
  );
};
TDGCertificate.propTypes = {
  name: PropTypes.string,
  //   course: PropTypes.string,
  dateCompleted: PropTypes.string,
  expiryDate: PropTypes.string,
  certNumber: PropTypes.string,
  fullCourse: PropTypes.object,
  employer: PropTypes.string,
  address: PropTypes.string,
  courseId: PropTypes.string,
  userId: PropTypes.string,
  setSubmitted: PropTypes.func,
  setStatus: PropTypes.func,
};

export default TDGCertificate;
